import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ProjectCancellationDetailsRoute extends Route {
  /**
   * Register services
   */
  @service router;
  @service session;

  /**
   * @inheritDoc
   */
  activate(transition) {
    super.activate(...arguments);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowSimpleHeader', true);

    if (this.session.currentUser.isSeller) {
      applicationController.set('simpleHeaderText', 'Confirm cancellation');
    } else {
      applicationController.set('simpleHeaderText', 'Request cancellation');
    }

    applicationController.set('simpleHeaderRightText', 'Cancel');
    applicationController.set('simpleHeaderRightAction', () => {
      const application  = this.modelFor('project-cancellation');
      this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__DETAILS, application.id);
    });

    trackPageViewFromTransition(this, transition, '/project/:id/cancel/details/');
  }

  /**
   * @inheritDoc
   */
  deactivate() {
    super.deactivate(...arguments);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowSimpleHeader', false);
    applicationController.set('simpleHeaderText', '');
    applicationController.set('simpleHeaderRightText', '');
    applicationController.set('simpleHeaderRightAction', null);
  }
}

export default ProjectCancellationDetailsRoute;
